import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Impact.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Impact = () => {
    
    const goals = [
        {
            goal: 'To proactively identify and mitigate potential risks and negative impacts on individuals, groups, and society while maximizing the benefits of AI technology.',
            PreGoal:'Goal IA1:',
            description: 'An impact assessment for responsible AI (RAI) is a critical process for ensuring that AI systems are developed and deployed ethically, transparently, and with consideration for potential risks and impacts.  The key requirements are:',
            requirements: [
                {
                    id: 'Core Principles:',
                    subRequirements2: [
                        "Accountability: Clearly defining roles and responsibilities for the development, deployment, and maintenance of the AI system. Establishing mechanisms for addressing concerns and ensuring accountability for the system's impact.",
                        "Transparency: Providing clear explanations of how the AI system works, its limitations, and the potential risks and benefits associated with its use. Ensuring that users understand how the system makes decisions and the data it uses.",
                        "Fairness: Identifying and mitigating potential biases in the AI system's data, algorithms, and outputs. Ensuring that the system treats all individuals and groups fairly and avoids discriminatory outcomes.",
                        "Reliability and Safety: Thoroughly testing and validating the AI system to ensure its reliability, accuracy, and safety. Implementing safeguards to prevent unintended consequences and mitigate risks.",
                        "Privacy and Security: Protecting the privacy and security of personal data used by the AI system. Implementing measures to prevent unauthorized access, data breaches, and misuse of information.",
                        "Inclusiveness: Designing the AI system to be accessible and usable by diverse populations, considering different abilities, cultures, and perspectives. Ensuring that the system does not perpetuate or exacerbate existing inequalities.",
                    ],
                    
                },
                {
                    id: 'Key Assessment Areas:',
                    text: "Purpose and Scope: Clearly define the purpose of the AI system, its intended use cases, and its target audience. Identify the potential benefits and risks associated with the system's deployment.",
                    subRequirements2: [
                        "Data: Assess the quality, relevance, and representativeness of the data used to train and operate the AI system. Identify potential biases and address them through appropriate data cleaning, pre-processing, or algorithmic adjustments.",
                        "Algorithm: Analyse the algorithm's design and implementation, ensuring that it is transparent, explainable, and auditable. Assess the potential for unintended consequences or biases in the algorithm's decision-making processes.",
                        "Human-AI Interaction: Evaluate how humans interact with the AI system. Consider factors such as user interface design, transparency of the system's actions, and mechanisms for user feedback and control.",
                        "Impact on Individuals and Society: Assess the potential impact of the AI system on individuals, groups, and society as a whole. Consider both positive and negative impacts, including potential discriminatory outcomes, social and economic effects, and ethical implications.",
                        "Monitoring and Evaluation: Establish mechanisms for ongoing monitoring and evaluation of the AI system's performance and impact. Regularly assess the system's effectiveness, identify potential issues, and implement necessary changes or updates.",
                        "Governance and Accountability: Develop governance structures and processes to ensure responsible AI development and deployment. Clearly define roles and responsibilities, establish mechanisms for oversight and accountability, and create channels for feedback and redress.",
                    ],
                    
                },
                {
                    id: 'Additional Considerations:',
                    subRequirements2: [
                        "Legal and Regulatory Compliance: Ensure that the AI system complies with relevant laws and regulations, such as data protection laws, anti-discrimination laws, and sector-specific regulations.",
                        "Ethical Considerations: Reflect on the ethical implications of the AI system, considering issues such as fairness, transparency, autonomy, and human dignity. Consult with ethicists and other stakeholders to ensure ethical decision-making throughout the development and deployment process.",
                        "Stakeholder Engagement: Engage with relevant stakeholders, including users, affected communities, and experts, to gather diverse perspectives and address concerns related to the AI system's impact.",
                    ],
                    
                },
                

            ]
        },
    ];
 



    const goal = goals[0];


    return (
        <div style={{ backgroundColor: 'rgb(240, 242, 245)', height: '100%' }}>
          <div className='dashcontent'>
            <div>
                <h2>Impact Assessment</h2>
            </div>
            <h2 className="goal-title">
              <span className="goal-prefix">{goal.PreGoal}</span> <span className="Impact-goal-name">{goal.goal}</span>
            </h2>
            <p className="applies-to">{goal.description}</p>
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="Impact-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goal.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong>
                        <br/>{requirement.text}
                        {requirement.subRequirements2 && (
                            <ul className="sub-requirements2-list">
                            {requirement.subRequirements2.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>              
            </div>
          </div>
        </div>
      );
};

    

export default Impact;